const o=(o=500)=>{setTimeout((()=>{window.location.reload()}),o)};export{o as reloadPage};
